import React from 'react';
// import PropTypes from 'prop-types';
import { Link } from 'gatsby'
// import Helmet from 'react-helmet'
import logo from '../images/meegrow/white_logo.png'
import $ from "jquery";

const propTypes = {};

const defaultProps = {};

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount(){
    $(window).on('scroll', function () {
      var scrollPos = $(this).scrollTop();
      if (scrollPos >= 20) {
          $(".header").addClass("fixed-nav");
      } else {
          $(".header").removeClass("fixed-nav");
      }
  })

  $( ".navbar-toggler" ).click(function() {
    $( '#navbarNav' ).toggleClass( "collapse" );
  });
  }

  render() {
    return (
      <header id="header" className="header arrow-header gred-bg">
                <nav className="navbar navbar-expand-lg">
                        <div className="container">
                            <div className="navbar-header">
                                <Link className="navbar-brand" to="/">
                                    <img src={logo} alt="logo" />
                                </Link>
                                <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarNav"
                                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                            <div className="collapse navbar-collapse" id="navbarNav">
                                <div className="navbar-nav ml-auto align-items-center">
                                    <Link activeClassName="active" className="scroll-item nav-link" data-scroll-nav="0"  to="/">Home</Link>
                                    <div className="product">
                                        <span className=" scroll-item nav-link product-link">Products</span>
                                        <div className="product-menu">
                                            <Link activeClassName="active" className="scroll-item nav-link text-left" to="/product/tv-measure">TV Measurement</Link>
                                            <Link activeClassName="active" className="scroll-item nav-link text-left" to="/product/media-market">Media Mix Simulator</Link>
                                            <Link activeClassName="active" className="scroll-item nav-link text-left" to="product/tv-plan">TV Plan Optimizer</Link>
                                            <Link activeClassName="active" className="scroll-item nav-link text-left" to="/product/campaign-analysis">Campaign Analytics</Link>
                                        </div>
                                      </div>
                                    {/* <Link className="scroll-item nav-link" to="/career" activeClassName="active" >Career</Link> */}
                                    {/* <Link className="scroll-item nav-link" to="/about" activeClassName="active" >About Us</Link> */}
                                    <Link className="scroll-item nav-link" to="/contact" activeClassName="active" >Contact</Link>
                                </div>
                            </div>
                        </div>
                     </nav>
        </header>
    );
  }
}

 Header.propTypes = propTypes;
 Header.defaultProps = defaultProps;